module.exports = __webpack_public_path__ + "img/redLine.466c9fa5.png";